import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Value (USD)", two_table_header: "Total Value (USD)" },
  { value: "weight", label: "Total Weight (kg)", two_table_header: "Total Weight (kg)" },
  // { value: 'teu', label: 'Total TEU'},
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Colombia Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  isViewAllGridNew: true,
  showUiTrends: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2019-01",
  isImpExpGraph: true,
  isUIGridNew: true,
  isUEGridNew: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  ],

  //   sortKeyUniqueImpExpMap: {
  //     shipment_value: 'shipment_value',
  //     date: 'doc_count',
  //     weight: 'weight'
  // },
  apiEndPoints: {
    getArrivalDate: getApiUrl("colombiaExportLatestArrivalDate"),
    getSearchResult: getApiUrl("colombiaExportSearch"),
    getAnalyticsData: getApiUrl("analytics/colombiaExportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_colombia_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_colombia_exports"),
    getShipmentByID: getApiUrl("colombiaExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfColombiaExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/colombiaExportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchColombiaExportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.co_export.country_small,
  countryCaps: globalCountryDetails.co_export.country_caps,
  product_id: globalCountryDetails.co_export.product_id,
  compare_product_id: globalCountryDetails.co_export.compareProduct,
  country_CamelCase: globalCountryDetails.co_export.product_id,
  countryCode: globalCountryDetails.co_export.countryCode,
  countryType: globalCountryDetails.co_export.countryType,
  manyCountryType: globalCountryDetails.co_export.manyCountryType,
  countryTypeCode: globalCountryDetails.co_export.countryTypeCode,
  redirectionID: globalCountryDetails.co_export.redirectionID,
  analyticsCountryID: globalCountryDetails.co_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Declaration Date Range",
  monthRangeHeading: "Month of Process",
  picker: {
    monthPicker: true,
    datePicker: false,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: false,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    ports: true,
  },
  searchCategoryList: globalCountryDetails.co_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortName",
  },
  filterObj: {
    transportMode: "transportMode",
    paymentMethod: "paymentMethod",
    exportDepartment: "exportDepartment",
    standardLadingPortName: "standardLadingPortName",
    shipperName: "shipperName",
    destinationCountryRegion: "destinationCountryRegion",
    countryOfExportRegion: "countryOfExportRegion",
    hsCode: "hsCode",
    weight: "weight",
    shipmentValue: "shipmentValue",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    consigneeName: "consigneeName",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {},
  boxRangeFilterList: {
    weight: "weight",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    weight: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    destinationCountryRegion: "destinationCountry",
    countryOfExportRegion: "countryOfExport",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    transportMode: [],
    paymentMethod: [],
    exportDepartment: [],
    standardLadingPortName: [],
    shipperName: [],
    destinationCountryRegion: [],
    countryOfExportRegion: [],
    hsCode: [],
    weight: [],
    shipmentValue: [],
    sections: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    consigneeName: [],
    derivedConsigneeMasterName: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {},
  selectAll: {
    transportMode: false,
    paymentMethod: false,
    exportDepartment: false,
    standardLadingPortName: false,
    shipperName: false,
    destinationCountryRegion: false,
    countryOfExportRegion: false,
    hsCode: false,
    weight: false,
    shipmentValue: false,
    sections: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    consigneeName: false,
    derivedConsigneeMasterName: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
  },

  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: categoryType.shipperDetails, eventKey: "16", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: categoryType.shipperDetails, eventKey: "2", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "", altKey: "foreignPort" },
    { heading: "Filter by Consignee Standardized Name", categoryName: categoryType.consigneeDetails, eventKey: "18", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: categoryType.consigneeDetails, eventKey: "3", key: "consigneeName", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "1", key: "destinationCountryRegion", altKey: "destinationCountry", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Jurisdiction Country", categoryName: categoryType.consigneeDetails, eventKey: "25", key: "consigneeJurisdictionCountryRegion", altKey: "consigneeJurisdictionCountry", type: filterType.localizeFilter, label: "Consignee Jurisdiction Country", viewAllPlaceHolder: "Search Consignee Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Jurisdiction Country", categoryName: categoryType.shipperDetails, eventKey: "25", key: "shipperJurisdictionCountryRegion", altKey: "shipperJurisdictionCountry", type: filterType.localizeFilter, label: "Shipper Jurisdiction Country", viewAllPlaceHolder: "Search Shipper Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "1", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by State of Export", categoryName: categoryType.shipperDetails, eventKey: "4", key: "exportDepartment", type: filterType.normalFilter, label: "State of Export", viewAllPlaceHolder: "Search in State of Export Filter", emptyFilterText: "", searchFilterString: "", altKey: "buyerState" },
    { heading: "Filter by Payment Method", categoryName: categoryType.freightType, eventKey: "8", key: "paymentMethod", type: filterType.normalFilter, label: "Payment Method", viewAllPlaceHolder: "Search in Payment Method Filter", emptyFilterText: "", searchFilterString: "", radioPresent: true, defaultFlag: true, radioText: "Exclude Shipments With Blank Consignees", radioKey: "exclude_blank_consignee" },
    { heading: "Filter by Customs Office", categoryName: categoryType.ports, eventKey: "10", key: "standardLadingPortName", type: filterType.normalFilter, label: "Customs Office", viewAllPlaceHolder: "Search in Customs Office Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: categoryType.freightType, eventKey: "11", key: "transportMode", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", optionOne: "Exclude", optionTwo: "Include", defaultFlag: true },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "12", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "12", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: categoryType.cargoDetails, eventKey: "13", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value", viewAllPlaceHolder: "Shipment Value", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight (kg)", categoryName: categoryType.cargoDetails, eventKey: "14", key: "weight", type: filterType.boxFilter, label: "Weight (kg)", viewAllPlaceHolder: "Weight (kg)", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
  ],

  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  highLightedColumnList: [
    { key: "hs_code", label: "HS Code" },
    { key: "colombian_entity_business_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "derived_nit_number", label: "Shipper NIT Number" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_customs_office_name", label: "Customs Office" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "consignee_name", label: "Consignee Name" },
    { key: "shipper_address", label: "Shipper Address" },
    { key: "consignee_address", label: "Consignee Address" },
  ],
  shipmentSorting: [
    { columnKey: "month_of_process", value: "date", isDefault: true },
    { columnKey: "gross_weight_kilos", value: "weight", isDefault: false },
    { columnKey: "fob_value_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "month_of_process",
    weight: "gross_weight_kilos",
    shipment_value: "fob_value_usd",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipment Value (USD)", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
    { label: "Total Net Weight", key: "total_weight", valuePrefix: "", valueSuffix: "Kg" },
  ],

  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "destinationCountryRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_destination", filterKey: "destinationCountryRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_place_of_departure" },
    // { key: "derived_colombia_origin_position_state_name", filterKey: "originDepartment", label: "States of Origin", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_colombia_origin_state_name" },  // required later after data insertion
    { key: "derived_colombia_origin_state_name", filterKey: "exportDepartment", label: "States of Export", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_colombia_origin_position_state_name" },
    // { key: "derived_place_of_departure", filterKey: "departmentPlace", label: "Places of Departure", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination" },  // required later after data insertion
    { key: "derived_customs_office_name", filterKey: "standardLadingPortName", label: "Customs Offices", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination", profileType: redirectingProfileEnum.portOfLading.key },
    { key: "derived_export_modality_english", filterKey: "exportMode", label: "Export Modes", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "derived_transportation_route_english", filterKey: "transportMode", label: "Top Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination" },
    { key: "derived_certificate_of_origin", filterKey: "certificateOfOrigin", label: "Top Certificates of Origin", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "derived_payment_method_english", filterKey: "paymentMethod", label: "Top Payment Methods", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    // {key: 'trade_origin_state_destination_country', filterKey1: 'originDepartment', filterKey2: 'destinationCountryRegion', label: 'Trade Routes (State of Origin -> Country of Import)', headerOne: 'State of Origin', headerTwo: 'Country of Import', filterOne: 'state', filterTwo: 'destinationCountry', keyOne: 'state', keyTwo: 'destinationCountry', keyTwoCountryCode: 'destinationCountryCode', type: analyticsType.topTwo, showTrends: true, grpType:'multi',showlevelTwo:true, defaultKey:'derived_shipper_master_name'},
    // { key: "trade_export_state_destination_country", filterKey1: "exportDepartment", filterKey2: "destinationCountryRegion", label: "Trade Routes (State of Export -> Country of Import)", headerOne: "State of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    // {key: 'trade_origin_export_state_departure_destination', filterKey1: 'originDepartment', filterKey2: 'exportDepartment', filterKey3: 'departmentPlace', filterKey4: 'destinationCountryRegion', label: 'Trade Routes (State of Origin -> State of Export -> Place of Departure -> Country of Import)', filterOne: 'filterField1', filterTwo: 'filterField2', filterThree: 'filterField3', filterFour: 'filterField4', keyOne: 'field1Country', keyTwo: 'field2Country', keyThree: 'field3Country', keyFour: 'field4Country', cityOne: 'field1', cityTwo: 'field2', cityThree: 'field3', cityFour: 'field4', keyOneCountryCode: 'field1CountryCode', keyTwoCountryCode: 'field2CountryCode', keyThreeCountryCode: 'field3CountryCode', keyFourCountryCode: 'field4CountryCode', type: analyticsType.topFour, grpType:'multi',showTrends: true, showlevelTwo:true, defaultKey:'derived_shipper_master_name'},
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "month_of_process", name: "Month of Process", selector: "month_of_process", dataTip: "", type: "", dateFormat: "MMM, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "hs_code", name: "HS Code", selector: "hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    // {name: 'Product', selector: 'product_description', tooltipValue: 'product_description', type: '', grow: 1, wrap: true, isSliceEnabled: true, sliceLength: 40,},
    { key: "number_of_units", name: "Quantity", selector: "number_of_units", secondarySelector: "derived_unit_of_measurement_english", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "net_weight_kilos", name: "Net Weight (kg)", selector: "net_weight_kilos", dataTip: "", type: "", sortable: true, grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "derived_shipper_master_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true },
    { key: "derived_country_of_destination", name: "Country of Import", selector: "derived_country_of_destination", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "80px", maWidth: "80px" },
    { key: "fob_value_usd", name: "Shipment Value (USD)", selector: "fob_value_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "weight", name: "Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Month of Process", value: "month_of_process", dateFormat: false, monthFormat: true, preValidate: true },
        { label: "Export Mode", value: "derived_export_modality_english", tooltip: true, tooltipField: "derived_export_modality_spanish", preValidate: true },
        { label: "Mode of Transportation", value: "derived_transportation_route_english", tooltip: true, tooltipField: "derived_transportation_route_spanish", preValidate: true },
        { label: "HS Code", value: "hs_code", preValidate: true },
        { label: "Payment Method", value: "derived_payment_method_english", tooltip: true, tooltipField: "derived_payment_method_spanish", preValidate: true },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "State of Origin", value: "derived_colombia_origin_position_state_name", info: "State where the last phase of the production process of exported goods was grown, processed or carried out", preValidate: true },
        { label: "State of Export", value: "derived_colombia_origin_state_name", info: "State from which the merchandise is dispatched abroad", preValidate: true },
        { label: "Place of Departure", value: "derived_place_of_departure", preValidate: true },
        { label: "Certificate of Origin", value: "derived_certificate_of_origin", tooltip: true, tooltipField: "derived_certificate_of_origin_spanish", preValidate: true },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
        { label: "Shipper Name", value: "derived_shipper_master_name", preValidate: true },
        { label: "Shipper NIT Number", value: "derived_nit_number", preValidate: true },
        { label: "Shipper Address", value: "shipper_address", isReadMore: true, readMoreLength: 45 },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code", preValidate: true },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_name", companyKey: "derived_consignee_master_name", derivedCompanyKey: "derived_consignee_master_name" },
        { label: "Consignee Name", value: "consignee_name", capitalize: "true", preValidate: true },
        { label: "Consignee Address", value: "consignee_address", isReadMore: true, readMoreLength: 45 },
        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 4,
      title: "Customs Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Customs Office", value: "derived_customs_office_name", preValidate: true, type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        { label: "Special System", value: "derived_type_of_system", preValidate: true },
      ],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Gross Weight (kg)", value: "gross_weight_kilos", preValidate: true },
        { label: "Net Weight (kg)", value: "net_weight_kilos", preValidate: true },
        { label: "Quantity", value: "number_of_units", unitField: "derived_unit_of_measurement_english_with_alpha", dynamicUnit: true, unitField2: "unit_of_measurement_alpha", dynamicUnit2: true, tooltip: true, tooltipPrefix: "COP ", tooltipField: "derived_unit_of_measurement_spanish", preValidate: true },
        { label: "FOB Value", value: "fob_value_usd", valuePrefix: " USD ", tooltip: true, tooltipField: "fob_value_colombian_peso", tooltipPrefix: "COP ", preValidate: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Insurance Value", value: "insurance_value_usd", valuePrefix: " USD ", tooltip: true, tooltipField: "derived_insurance_value_cop", tooltipPrefix: "COP ", preValidate: true },
        { label: "Freight Value", value: "freight_value_usd", valuePrefix: " USD ", tooltip: true, tooltipField: "derived_freight_value_cop", tooltipPrefix: "COP ", preValidate: true },
        { label: "Other Expenses", value: "other_expenses_value_usd", valuePrefix: " USD ", tooltip: true, tooltipField: "derived_other_expenses_value_cop", tooltipPrefix: "COP ", preValidate: true },
        { label: "CIF Value", value: "derived_cif_value_usd", valuePrefix: " USD ", tooltip: true, tooltipField: "derived_cif_value_cop", tooltipPrefix: "COP ", preValidate: true },
        { label: "Total National Value Added", value: "total_value_added_colombia_usd", valuePrefix: " USD ", tooltip: true, tooltipField: "derived_total_value_added_colombia_cop", tooltipPrefix: "COP ", preValidate: true },
      ],
    },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_destination",
  twoColumnMapping: {
    // derived_consignee_master_name:"Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    derived_country_of_destination: "Countries of Import",
    derived_colombia_origin_position_state_name: "States of Origin",
    derived_colombia_origin_state_name: "States of Export",
    derived_place_of_departure: "Places of Departure",
    derived_customs_office_name: "Custom Offices",
    derived_export_modality_english: "Export Modes",
    derived_transportation_route_english: "Top Mode of Transportation",
    derived_certificate_of_origin: "Certificates of Origin",
    derived_payment_method_english: "Top Payment Methods",
    // trade_origin_state_destination_country:"Trade Routes (State of Origin -> Country of Import)",
    trade_export_state_destination_country: "Trade Routes (State of Export -> Country of Import)",
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",

    // trade_origin_export_state_departure_destination:"Trade Routes (State of Origin -> State of Export -> Place of Departure -> Country of Import)",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const PanamaExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default PanamaExportSearch;
